export default __webpack_public_path__ + "static/media/Saturno.00b7295f.png";